import { createContext, useContext, useLayoutEffect, useState, ReactNode } from 'react';

type ChromeContextValue = {
    hideChrome: boolean;
    setHideChrome: (value: boolean) => void;
};

const ChromeContext = createContext<ChromeContextValue>({
    hideChrome: false,
    setHideChrome: () => { },
});

export const ChromeProvider = ({ children }: { children: ReactNode }) => {
    const [hideChrome, setHideChrome] = useState(false);
    return <ChromeContext.Provider value={{ hideChrome, setHideChrome }}>{children}</ChromeContext.Provider>;
};

export const useChrome = () => useContext(ChromeContext);

/**
 * Wrap a route's page element with this to hide the admin header/footer while it is mounted.
 * Chrome visibility is decided by which page actually rendered, not by re-parsing the URL against
 * route patterns elsewhere - so it can't drift out of sync the way a separate path-matching check can.
 */
export const NoChrome = ({ children }: { children: ReactNode }) => {
    const { setHideChrome } = useChrome();
    useLayoutEffect(() => {
        setHideChrome(true);
        return () => setHideChrome(false);
    }, [setHideChrome]);
    return <>{children}</>;
};
